/* Elemence Shop Grid — plan toggle (One-time/Subscribe), per-card flavor
   swatches, dynamic prices/CTA. Cards without selling plans become "trial
   locked" in Subscribe mode — clicking their CTA flips the whole section
   back to One-time. */
(function () {
  function placePill(seg) {
    const pill   = seg.querySelector('.elemence-plan-seg__pill');
    const active = seg.querySelector('.elemence-plan-seg__btn.on');
    if (!pill || !active) return;
    pill.style.width = active.offsetWidth + 'px';
    pill.style.transform = `translateX(${active.offsetLeft - 4}px)`;
  }

  function initCard(card, root) {
    if (card.dataset.cardInit === '1') return;
    card.dataset.cardInit = '1';

    const dataEl = card.querySelector('script.elemence-shop-card__data');
    if (!dataEl) return;

    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data) return;

    const labels = data.labels || {};
    const variants = data.variants || [];
    const trialOnly = !!data.trial_only;

    const defaultVariant =
      variants.find((v) => v.id === data.default_variant_id) || variants[0];

    let state = {
      variantId: defaultVariant ? defaultVariant.id : null,
    };

    const swatches = card.querySelectorAll('.elemence-shop-card__swatch');
    const bg = card.querySelector('.elemence-shop-card__image-bg');
    const nowEl    = card.querySelector('.elemence-shop-card__price-now');
    const permoEl  = card.querySelector('.elemence-shop-card__price-permo');
    const wasEl    = card.querySelector('.elemence-shop-card__price-was');
    const perStEl  = card.querySelector('.elemence-shop-card__perstick-v');
    const ctaEl    = card.querySelector('.elemence-shop-card__cta');
    const form     = card.querySelector('form.elemence-shop-card__form');
    const idIn     = form ? form.querySelector('input[name="id"]') : null;
    const spIn     = form ? form.querySelector('input[name="selling_plan"]') : null;

    const getVariant = () => variants.find((v) => v.id === state.variantId) || defaultVariant;

    const render = () => {
      const plan = root.getAttribute('data-plan') || 'onetime';
      const v = getVariant();
      if (!v) return;

      const isSub = plan === 'subscribe' && !trialOnly && v.selling_plan_id != null;
      const isTrialLocked = plan === 'subscribe' && trialOnly;

      card.classList.toggle('elemence-shop-card--trial-locked', isTrialLocked);

      // Swatch active state
      swatches.forEach((s) => {
        s.classList.toggle('on', parseInt(s.getAttribute('data-variant-id'), 10) === v.id);
      });

      // Image swap if variant has its own
      if (bg && v.image) bg.setAttribute('src', v.image);

      // Prices — all formatted strings come pre-rendered from Liquid, so they
      // already reflect the active market's currency, locale, and money_format.
      const priceFormatted = isSub ? (v.sub_price_formatted || '') : (v.price_formatted || '');
      if (nowEl) nowEl.textContent = priceFormatted;
      if (permoEl) permoEl.hidden = !isSub;
      if (wasEl) {
        const showWas = isSub && v.price > v.sub_price;
        wasEl.hidden = !showWas;
        wasEl.textContent = showWas ? (v.price_formatted || '') : '';
      }
      if (perStEl) {
        perStEl.textContent = isSub ? (v.sub_perstick_formatted || '') : (v.perstick_formatted || '');
      }

      // CTA
      if (ctaEl) {
        if (isTrialLocked) {
          ctaEl.classList.add('elemence-shop-card__cta--switch-plan');
          ctaEl.textContent = labels.trial_message || 'Trial only - switch plan';
          ctaEl.setAttribute('type', 'button');
        } else {
          ctaEl.classList.remove('elemence-shop-card__cta--switch-plan');
          ctaEl.textContent = (isSub ? labels.cta_subscribe : labels.cta_onetime) || 'Add to Cart';
          if (form) ctaEl.setAttribute('type', 'submit');
        }
      }

      // Form sync
      if (idIn) idIn.value = v.id || '';
      if (spIn) spIn.value = isSub ? (v.selling_plan_id || '') : '';
    };

    swatches.forEach((s) => {
      s.addEventListener('click', () => {
        const vid = parseInt(s.getAttribute('data-variant-id'), 10);
        if (!isNaN(vid)) { state.variantId = vid; render(); }
      });
    });

    // Trial-locked CTA → flip section plan back to one-time
    if (ctaEl) {
      ctaEl.addEventListener('click', (e) => {
        if (card.classList.contains('elemence-shop-card--trial-locked')) {
          e.preventDefault();
          const oneBtn = root.querySelector('.elemence-plan-seg__btn[data-mode="onetime"]');
          if (oneBtn) oneBtn.click();
        }
      });
    }

    card._elemenceRender = render;
    render();
  }

  function initSection(root) {
    if (!root || root.dataset.gridInit === '1') return;
    root.dataset.gridInit = '1';

    const seg = root.querySelector('.elemence-plan-seg');
    const cards = root.querySelectorAll('.elemence-shop-card');

    cards.forEach((c) => initCard(c, root));

    if (seg) {
      placePill(seg);
      window.addEventListener('resize', () => placePill(seg));

      seg.querySelectorAll('.elemence-plan-seg__btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          seg.querySelectorAll('.elemence-plan-seg__btn').forEach((b) => b.classList.remove('on'));
          btn.classList.add('on');
          placePill(seg);
          const mode = btn.getAttribute('data-mode');
          root.setAttribute('data-plan', mode);
          cards.forEach((c) => { if (c._elemenceRender) c._elemenceRender(); });
        });
      });
    }
  }

  function init(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.elemence-shop-grid').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
